import * as React from 'react'
import { CheckIcon } from 'lucide-react'
import { cn } from '../../../lib/utils'

/**
 * Image message — rounded thumbnail with optional time + read status overlay.
 */
export interface ChatImageProps extends React.HTMLAttributes<HTMLDivElement> {
	src: string
	alt?: string
	time?: string
	readStatus?: 'sent' | 'read' | null
	align?: 'start' | 'end'
}

const ChatImage = React.forwardRef<HTMLDivElement, ChatImageProps>(
	({ className, src, alt = '', time, readStatus, align = 'start', ...props }, ref) => (
		<div
			ref={ref}
			data-slot="chat-image"
			className={cn(
				'relative w-[200px] overflow-hidden rounded-(--radius-md)',
				align === 'end' ? 'self-end' : 'self-start',
				className
			)}
			{...props}
		>
			<img src={src} alt={alt} className="h-auto w-full object-cover" />
			{(time || readStatus) && (
				<div className="absolute bottom-2 right-2 flex items-center gap-1 rounded-full bg-black/40 px-2 py-0.5 text-xs leading-4 text-white">
					{time && <span>{time}</span>}
					{readStatus && (
						<span className="flex items-center">
							<CheckIcon className="size-3" />
							{readStatus === 'read' && <CheckIcon className="-ml-1.5 size-3" />}
						</span>
					)}
				</div>
			)}
		</div>
	)
)

ChatImage.displayName = 'ChatImage'
export { ChatImage }
